<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M13.0998 12.4029C16.1998 12.4029 18.7998 9.9029 18.7998 6.7029C18.7998 3.6029 16.2998 1.0029 13.0998 
    1.0029C9.8998 0.902898 7.2998 3.4029 7.2998 6.6029C7.2998 9.8029 9.8998 12.4029 13.0998 12.4029Z"
    fill="#748097"
  />
  <path
    d="M11.2998 28.3029V31.4029C11.2998 31.7029 11.4998 31.9029 11.7998 31.9029H14.8998C14.9998 31.9029 15.1998 
    31.8029 15.2998 31.7029L26.4998 20.5029L22.5998 16.6029L11.3998 28.0029C11.2998 28.1029 11.2998 28.2029 11.2998 
    28.3029ZM29.4998 17.6029C29.8998 17.2029 29.8998 16.6029 29.4998 16.2029L27.0998 13.8029C26.6998 13.4029 26.0998 
    13.4029 25.6998 13.8029L23.7998 15.7029L27.6998 19.6029C27.5998 19.5029 29.4998 17.6029 29.4998 17.6029Z"
    fill="#009DD6"
  />
  <path
    d="M20.5 15.3028C19.6 14.8028 18.6 14.6028 17.5 14.6028H8.7C4.9 14.6028 2 17.6028 2 21.3028V23.9028C2 24.5028 2.4 
    24.9028 3 24.9028H10.9L20.5 15.3028Z"
    fill="#748097"
  />
</svg>
